export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "inactive-link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inactive link"])}
      },
      "fr": {
        "inactive-link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lien inactif"])}
      }
    }
  })
}
